import { logger } from '@tuic/logger';

import { Mps } from '../../index';
import { errorContains } from '../../utils/error';

import type { TriggerPreferenceMailRequest } from '../../generated/mps';
import type { Locale } from '@tuic/i18n';

type RecipientData = {
  email: string;
  type: TriggerPreferenceMailRequest['type'] | 'NL_PREFERENCE';
  locale: TriggerPreferenceMailRequest['locale'] | Locale;
};

export enum TRIGGER_NEWSLETTER_PREFERENCES_EMAIL_RESPONSE {
  SUCCESS,
  GENERAL_ERROR,
  RECIPIENT_DOES_NOT_EXIST,
}

export async function triggerNewsletterPreferences(
  recipient: RecipientData,
): Promise<TRIGGER_NEWSLETTER_PREFERENCES_EMAIL_RESPONSE> {
  const { error } = await Mps.triggerTransactionMail({
    body: {
      ...recipient,
      locale:
        recipient.locale?.toUpperCase() as TriggerPreferenceMailRequest['locale'],
    },
  });

  if (!error) {
    return TRIGGER_NEWSLETTER_PREFERENCES_EMAIL_RESPONSE.SUCCESS;
  }

  if (errorContains(error, 'recipient not found')) {
    return TRIGGER_NEWSLETTER_PREFERENCES_EMAIL_RESPONSE.RECIPIENT_DOES_NOT_EXIST;
  }

  logger.error('[MPS] Failed triggering transaction mail.');
  logger.error(error);

  return TRIGGER_NEWSLETTER_PREFERENCES_EMAIL_RESPONSE.GENERAL_ERROR;
}
